import { ClosestPointTooltip } from './ClosestPointTooltip/ClosestPointTooltip.js';
import { useDotData } from '../../hooks/useDotData.js';
import type { DotSeriesWithDatapoints } from '../../types/xy-chart-internals.js';
import type { DotDatapoint } from '../../types/xy-chart.js';

export function DotSeriesTooltip({
  datapoint,
  series,
}: Readonly<{
  datapoint: DotDatapoint;
  series: DotSeriesWithDatapoints;
}>) {
  const { seriesToMetadata } = useDotData();
  return (
    <ClosestPointTooltip
      datapoint={datapoint}
      series={series}
      seriesToMetadata={seriesToMetadata}
    />
  );
}
